export default "__VITE_ASSET__Bhokp4TI__"